import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SlicePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';

import { AuthDialogModule } from 'src/app/shared/dialogs/auth-dialog/auth-dialog.module';

import { AuthService } from 'src/app/core/services/auth.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';

import { ViatorGroupComponent } from './viator-group/viator-group.component';
import { NoItemsFoundComponent } from '../../components/no-items-found/no-items-found.component';
import { ViatorListMobileComponent } from 'src/app/modules/countries/components/mobile/viator-list-mobile/viator-list-mobile.component';

export interface IViatorEvent {
  id: string;
  currency: string;
  imageUrl: string;
  name: string;
  price: number;
  url: string;
  image?: { url: string }[];
}

export interface IViatorCategories {
  [key: string]: IViatorEvent[];
}

@Component({
  selector: 'app-viator',
  templateUrl: './viator.component.html',
  styleUrls: ['./viator.component.scss'],
  imports: [
    NgxSkeletonLoaderModule,
    MatIconModule,
    AuthDialogModule,
    ViatorGroupComponent,
    FormsModule,
    TranslateModule,
    SlicePipe,
    ViatorListMobileComponent,
    NoItemsFoundComponent,
    MatCheckbox,
  ],
})
export class ViatorComponent implements OnInit, OnChanges {
  @Input() cityId: string | number = 0;
  @Input() categories: IViatorCategories;
  @Input() countryName: string = '';
  @Input() cityName: string = '';
  @Input() isFetching: boolean = false;
  @Output() selectedCategory = new EventEmitter<any>(); // need to delete
  @Output() numOfHurt = new EventEmitter<number>();
  @Output() numOfAllHurted = new EventEmitter<number>();

  public viArray: { type: string; events: IViatorEvent[] }[] = [];
  public showFilters: boolean = true;
  public filters: { name: string; count: number; selected: boolean }[] = [];
  public selectedFilters: string[] = [];
  public fetchingItems: number[] = new Array(2);
  public fetchingFilters: number[] = new Array(5);

  public readonly eSvgIcons = ESvgIcons;

  @ViewChild('viatorSwiperContainer') swiperContainer: ElementRef;

  constructor(
    private readonly googleAnalyticService: GoogleAnalyticService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    protected breakpointService: BreakpointService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['categories']) {
      this.viArray = [];
      this.categories = changes['categories'].currentValue;
      this.resetFilters();
      this.cdr.markForCheck();
    }
  }

  clickBookNow(
    vi: { type: string; events: IViatorEvent[] },
    item: IViatorEvent,
  ): void {
    this.googleAnalyticService.setViatorAnalytic({
      activityName: item.name,
      countryName: this.countryName,
      cityName: this.cityName,
      type: vi.type,
      userID: this.authService.userId,
    });
  }

  setPriorityCategory(): void {
    this.viArray = Object.entries(this.categories)
      .filter(([key]) => this.selectedFilters.includes(key))
      .reduce((acc, [key, value]) => {
        acc = [
          ...acc,
          {
            type: key,
            events: value,
          },
        ];
        return acc;
      }, []);
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
    this.cdr.markForCheck();
  }

  onFilterChange(filterName: string, isSelected: boolean) {
    if (isSelected) {
      this.selectedFilters.push(filterName);
    } else {
      this.selectedFilters = this.selectedFilters.filter(
        (f) => f !== filterName,
      );
    }

    this.setPriorityCategory();
  }

  resetFilters(): void {
    this.filters = [];
    this.viArray = [];

    for (const key in this.categories) {
      const filter: { name: string; count: number; selected: boolean } = {
        name: key,
        count: this.categories[key].length,
        selected: true,
      };

      if (this.viArray.length < 2) {
        this.selectedFilters.push(key);
      } else {
        filter.selected = false;
      }

      this.filters.push(filter);
      this.setPriorityCategory();
    }
  }
}
